module.exports = __webpack_public_path__ + "img/missoni_logo_black.353045d.png";